module.exports = __webpack_public_path__ + "media/images/icons/da_assegnare_test_ufficiale-271c297b475e873d56669a173e2d2c76.svg";